import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, PhoneIcon, MailIcon, InstagramIcon, ArrowUpIcon } from 'lucide-react';
import { BrandTiktok } from './icons/BrandTiktok';
export const Footer = () => {
  const [isShining, setIsShining] = useState(false);
  // Create a subtle shine effect every 5-6 seconds
  useEffect(() => {
    const shineInterval = setInterval(() => {
      setIsShining(true);
      // Reset the shine effect after it completes
      setTimeout(() => {
        setIsShining(false);
      }, 1500); // Duration of shine animation
    }, 5500); // Interval between shine effects (5.5 seconds)
    return () => clearInterval(shineInterval);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <footer className="bg-[#0a0a0a] text-[#CCCCCC] py-16 border-t border-[#222222] relative" data-id="element-169">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#222222] to-transparent" data-id="element-170"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-172">
          {/* Logo and info */}
          <div data-id="element-173">
            <div className="mb-8" data-id="element-174">
              <Link to="/" data-id="element-175">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6P9doWbYb8UgxtfPvK6o5M/BK-Customs-Logo-DEF-01-1973x2048.png" alt="BKCustoms Logo" className="h-20 w-auto" data-id="element-176" />
              </Link>
            </div>
            <p className="mb-6 text-sm max-w-xs" data-id="element-177">
              Premium car customization voor jouw unieke rijervaring.
              Vakmanschap en kwaliteit sinds 2010.
            </p>
            <div className="flex space-x-4" data-id="element-178">
              <a href="https://www.instagram.com/bk.customs36/" target="_blank" rel="noopener noreferrer" className="bg-[#121212] p-3 rounded-full hover:bg-[#D6281F] transition-colors duration-300 group" data-id="element-179">
                <InstagramIcon size={20} className="text-white group-hover:text-white" data-id="element-180" />
              </a>
              <a href="https://www.tiktok.com/@bk.customs36" target="_blank" rel="noopener noreferrer" className="bg-[#121212] p-3 rounded-full hover:bg-[#D6281F] transition-colors duration-300 group" data-id="element-181">
                <BrandTiktok size={20} className="text-white group-hover:text-white" data-id="element-182" />
              </a>
            </div>
          </div>
          {/* Contact info */}
          <div data-id="element-183">
            <h3 className="text-xl font-semibold text-white mb-6" data-id="element-184">Contact</h3>
            <div className="space-y-4" data-id="element-185">
              <div className="flex items-start" data-id="element-186">
                <MapPinIcon size={20} className="mr-3 mt-1 flex-shrink-0 text-[#D6281F]" data-id="element-187" />
                <span className="text-sm" data-id="element-188">
                  Microfoonstraat 36
                  <br data-id="element-189" />
                  1322 BN Almere
                </span>
              </div>
              <div className="flex items-center" data-id="element-190">
                <PhoneIcon size={20} className="mr-3 flex-shrink-0 text-[#D6281F]" data-id="element-191" />
                <a href="tel:+31627888306" className="text-sm hover:text-white transition-colors duration-300" data-id="element-192">
                  +31 (0)6 278 88 306
                </a>
              </div>
              <div className="flex items-center" data-id="element-193">
                <MailIcon size={20} className="mr-3 flex-shrink-0 text-[#D6281F]" data-id="element-194" />
                <a href="mailto:info@bkcustoms.nl" className="text-sm hover:text-white transition-colors duration-300" data-id="element-195">
                  info@bkcustoms.nl
                </a>
              </div>
            </div>
            <div className="mt-8" data-id="element-196">
              <h4 className="text-white font-medium mb-2" data-id="element-197">Openingstijden</h4>
              <p className="text-sm" data-id="element-198">Ma - Za: 08:00 - 19:30</p>
              <p className="text-sm" data-id="element-199">Zo: Op afspraak</p>
            </div>
          </div>
          {/* Navigation */}
          <div data-id="element-200">
            <h3 className="text-xl font-semibold text-white mb-6" data-id="element-201">Navigatie</h3>
            <div className="grid grid-cols-2 gap-2" data-id="element-202">
              <ul className="space-y-2" data-id="element-203">
                <li data-id="element-204">
                  <Link to="/" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-205">
                    Home
                  </Link>
                </li>
                <li data-id="element-206">
                  <Link to="/diensten" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-207">
                    Diensten
                  </Link>
                </li>
                <li data-id="element-208">
                  <Link to="/over-ons" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-209">
                    Over ons
                  </Link>
                </li>
              </ul>
              <ul className="space-y-2" data-id="element-210">
                <li data-id="element-211">
                  <Link to="/contact" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-212">
                    Contact
                  </Link>
                </li>
                <li data-id="element-213">
                  <Link to="/veelgestelde-vragen-faq" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-214">
                    FAQ
                  </Link>
                </li>
                <li data-id="element-215">
                  <Link to="/algemene-voorwaarden" className="text-sm hover:text-[#D6281F] transition-colors duration-300" data-id="element-216">
                    Algemene voorwaarden
                  </Link>
                </li>
              </ul>
            </div>
            <button onClick={scrollToTop} className="mt-8 inline-flex items-center bg-[#121212] hover:bg-[#D6281F] text-white px-4 py-2 rounded-md transition-colors duration-300" data-id="element-217">
              <span className="mr-2 text-sm" data-id="element-218">Terug naar boven</span>
              <ArrowUpIcon size={16} data-id="element-219" />
            </button>
          </div>
        </div>
        <div className="border-t border-[#222222] mt-12 pt-8 text-center text-xs" data-id="element-220">
          <p className="mb-2" data-id="element-221">
            &copy; {new Date().getFullYear()} BKCustoms. Alle rechten
            voorbehouden.
          </p>
          <div className="text-[#999999] flex flex-wrap justify-center items-center gap-2" data-id="element-222">
            <Link to="/privacybeleid" className="text-[#D6281F] hover:text-white transition-colors duration-300" data-id="element-223">
              Privacybeleid
            </Link>
            <span className="text-[#444444]" data-id="element-224">|</span>
            <Link to="/algemene-voorwaarden" className="text-[#D6281F] hover:text-white transition-colors duration-300" data-id="element-225">
              Algemene voorwaarden
            </Link>
            <span className="text-[#444444]" data-id="element-226">|</span>
            <a href="https://www.radux.nl" target="_blank" rel="noopener noreferrer" className="relative text-[#666666] hover:text-white text-[10px] transition-all duration-300 overflow-hidden group" data-id="element-227">
              <span className="relative z-10" data-id="element-228">
                Powered by Radux Digital Agency
              </span>
              {/* Subtle shine effect */}
              <span className={`absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full ${isShining ? 'animate-shine' : ''}`} style={{
              transform: isShining ? 'translateX(200%)' : 'translateX(-100%)',
              transition: 'transform 1.5s ease-in-out'
            }} data-id="element-229"></span>
            </a>
          </div>
        </div>
      </div>
    </footer>;
};